import React, {useEffect, useState} from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';

import {
    Button as AlchemyButton,
    Tooltip as AlchemyTooltip,
} from '@amzn/alchemy-components-react';

import { setFavourites as setMyFavouriteItems } from '../../slices/myFavouritesSlice';
import { setFavourites as setSiteFavouriteItems } from '../../slices/siteFavouritesSlice';
import { addMessage } from '../../slices/messageQueueSlice';
import { FavouritesApiService } from '../../api';
import {itemTypes} from '../../enums/ItemTypes.enum';
import i18n from "../../i18n";
import { RootState } from '../../types';

interface AddFavoriteButtonProps {
    favoritesType: number;
    bookmark: any;
    size?: "sm" | "md" | "lg";
    iconSize?: string;
}

export default function(props: AddFavoriteButtonProps) {
    const favoritesType:number = props.favoritesType
    const favoriteData = props.bookmark
    const size = props.size || "sm"
    const iconSize = props.iconSize || "16"
    const [addToMyFav, setAddToMyFav] = useState(false)
    const [addToSiteFav, setAddToSiteFav] = useState(false)
    const [icon, setIcon] = useState<JSX.Element | null>(null)
    // TODO:https://code.amazon.com/packages/AlchemyComponents/commits/93a0285e3ca387fca878a5520d9680eaf4d870b7
    const [toolTipLabel, setToolTipLabel] = useState('add-new-bookmark-to')
    // local user detail here
    const currentUser = useSelector((state: RootState) => state.user);

    const dispatch = useAppDispatch();
    const favApi = new FavouritesApiService();

    useEffect(() => {
        switch (favoritesType) {
            case itemTypes.bookmarkCard:
                setAddToMyFav(true)
                setToolTipLabel(`${i18n.t('universal:add-new-bookmark-to')} ${currentUser.login}`)
                setIcon(<Icon.Heart size={iconSize} />)
                break;
            case itemTypes.myFavourites:
                setAddToSiteFav(true)
                setToolTipLabel(`${i18n.t('universal:add-new-bookmark-to')} ${currentUser.whid}`)
                setIcon(<Icon.Star size={iconSize} />)
                break;
            case itemTypes.siteFavourites:
                setAddToMyFav(true)
                setToolTipLabel(`${i18n.t('universal:add-new-bookmark-to')} ${currentUser.login}`)
                setIcon(<Icon.Heart size={iconSize} />)
                break;
        }
    }, [favoritesType])

    const addToFavorites = (favoriteType: number) => {
        let entity = ''
        let msg = ''
        let favoriteTypeStr = ''
        let dispathFunction:any
        switch (favoriteType) {
            case itemTypes.myFavourites:
                entity = currentUser.login
                msg = i18n.t('toast:added-for-you')
                favoriteTypeStr = "personal"
                dispathFunction = setMyFavouriteItems
                break
            case itemTypes.siteFavourites:
                entity = currentUser.whid
                favoriteTypeStr = "site"
                msg = `${i18n.t('toast:added-for')} ${currentUser.whid}`
                dispathFunction = setSiteFavouriteItems
                break
        }

        async function addFav() {
            const response: any = await favApi.addToEntityFav(entity, favoriteData.entity, favoriteTypeStr)
            // Api will return new status back can utilizate directly
            dispatch(dispathFunction(response['favorite_bookmarks']))
            dispatch(addMessage({
                id: Date.now().toString(),
                icon: "add",
                title: msg,
                text: favoriteData.title || favoriteData.description,
                duration: 5000
            }))
            // TODO: BETA
            // dispatch(addToast(
            //     Date.now().toString(),
            //     "info",
            //     "May I have your attention, please?",
            //     "This is currently a BETA test and bookmarks you create will not persist. Please do not use for production.",
            //     "",
            //     8000
            // ))
        }
        addFav();
    }

    const handleAddFavorites = () => {
        async function addToFavorite() {
            addToMyFav && addToFavorites(itemTypes.myFavourites)
            addToSiteFav && addToFavorites(itemTypes.siteFavourites)
        };
        addToFavorite()
    }

    return (
        <AlchemyTooltip position="top">
            <span slot="trigger">
                <AlchemyButton
                    size={size}
                    disabled={favoriteData.isExample}
                    onClick={() => handleAddFavorites()}>
                    {icon}
                </AlchemyButton>
            </span>
            <p className='mb-0'>
                {toolTipLabel}
            </p>
        </AlchemyTooltip>
    );
}
